// @ts-nocheck
import * as React from 'react';
// ScalingFrame — fills the viewport, provides the grid layout.

export default function ScalingFrame({ children }) {
  return <div className="frame-canvas">{children}</div>;
}
